type RelativeUnit = "year" | "month" | "week" | "day" | "hour" | "minute";

const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

const UNITS: [RelativeUnit, number][] = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["week", 60 * 60 * 24 * 7],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
];

/** "2 hours ago", "just now", etc. Falls back to "just now" under a minute. */
export function formatRelativeTime(iso: string): string {
  const seconds = (Date.parse(iso) - Date.now()) / 1000;
  for (const [unit, secondsInUnit] of UNITS) {
    if (Math.abs(seconds) >= secondsInUnit) {
      return rtf.format(Math.round(seconds / secondsInUnit), unit);
    }
  }
  return "just now";
}

/** Compact form for tight spaces (rail chat list): "2h", "3d", "just now". */
export function formatRelativeTimeCompact(iso: string): string {
  const seconds = (Date.now() - Date.parse(iso)) / 1000;
  if (seconds < 60) return "now";
  const table: [string, number][] = [
    ["y", 60 * 60 * 24 * 365],
    ["mo", 60 * 60 * 24 * 30],
    ["d", 60 * 60 * 24],
    ["h", 60 * 60],
    ["m", 60],
  ];
  for (const [suffix, secondsInUnit] of table) {
    if (seconds >= secondsInUnit) {
      return `${Math.floor(seconds / secondsInUnit)}${suffix}`;
    }
  }
  return "now";
}
